import React from 'react';
import { ReactComponent as CloseIcon } from '../../icons/svg/ic-close.svg';
import { ReactComponent as ArrowRightIcon } from '../../icons/svg/arrow-right.svg';
import ReactPlayer from 'react-player';
import $ from 'jquery';
import textTypes from './textTypes';
// import marked from 'marked';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import throttle from 'lodash/throttle';

// pdf implementation
import { Document, Page } from 'react-pdf';

class RenderPDF extends React.PureComponent {
    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages }, () => {
            this.props.setDivSizeManualCall();
        });
    }
    render() {
        return (
            <Document
                renderMode="canvas"
                file={this.props.pdfUrl}
                onLoadSuccess={this.onDocumentLoadSuccess}>
                <Page
                    width={this.props.wrapperDivSize}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                    pageNumber={1} />
            </Document>
        )
    }
}

class PdfComponent extends React.PureComponent {
    constructor(props) {
        super(props)

        this.state = { width: null };
      }
    
      componentDidMount () {
        this.setDivSize()
        window.addEventListener("resize", throttle(this.setDivSize, 500));
      }
    
      componentWillUnmount () {
        window.removeEventListener("resize", throttle(this.setDivSize, 500));
      }
    
      setDivSize = () => {
        this.setState({ width: this.pdfWrapper.getBoundingClientRect().width - (10 * 2) });
      }
    
      render() {
            return (
                <div ref={(ref) => this.pdfWrapper = ref} className={this.props.classList}>
                    <RenderPDF setDivSizeManualCall={this.setDivSize} pdfUrl={this.props.pdfUrl} wrapperDivSize={this.state.width} />
                </div>
            )
      }
}

export default class PostPopUp extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            postObj: this.props.postObj,
            bodyObjList: [],
            bodyBottomObjList: [],
            shareLinkOpenInNewTab: false,
            shareLink: '',
            isEmailSharingDetailsOpen: false,
            isCopiedLink: false,
            downloadUrl: '',
            downloadTitle: '',
            sharingUrl: ''
        }

        this.postBodyModelType = {
            "TEXT_FIELD": "TEXT_FIELD",
            "IMAGE_FIELD": "IMAGE_FIELD",
            "STAT_FIELD": "STAT_FIELD",
            "PDF_FIELD": "PDF_FIELD",
            "VIDEO_FIELD": "VIDEO_FIELD"
        };

        this.acceptableImagePositions = [
            "Top",
            "Center",
            "Bottom"
        ];

        this.richTextRenderOptions = {
            renderNode: {
                'embedded-asset-block': this.handleRichTextAssets
            }
        }

        this.shareRef = React.createRef();
        this.downloadRef = React.createRef();

        this.populatePostBodyList(this.props.postObj);
    }
    handleRichTextAssets(node) {
        if (node.data.target.fields.file.contentType.indexOf('image') != -1) {
            return <img className="rich-text-asset rich-text-asset-image img-fluid" src={node.data.target.fields.file.url + "?h=1000&q=85"} />
        } else if (node.data.target.fields.file.contentType.indexOf('application/pdf') != -1) {
            return <embed className="rich-text-asset rich-text-asset-pdf" src={node.data.target.fields.file.url} type="application/pdf"></embed>;
        } else if (node.data.target.fields.file.contentType.indexOf('video/mp4') != -1) {
            const videoHtml = <div className="post-body-video-field">
                <ReactPlayer className="rich-text-asset" height={'100%'} url={node.data.target.fields.file.url} controls />
            </div>
            return videoHtml;
        }
    }
    handleKeyDown(event) {
        if (this.props.isOpen) {
            if (event.keyCode === 37) { // checks whether the pressed key is "Left Arrow"
                this.props.loadInPreviousArticle(this.state.postObj.currentIndex)
            } else if (event.keyCode === 39) { // checks whether the pressed key is "Right Arrow"
                this.props.loadInNextArticle(this.state.postObj.currentIndex)
            }
        }
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }
    componentDidMount() {
        document.addEventListener('keydown', e => this.handleKeyDown(e));
    }
    componentDidUpdate(prevProps) {
        if (this.props.postObj !== prevProps.postObj) {
            this.setState({ postObj: this.props.postObj });
            this.openPost(this.props.postObj);
            this.populatePostBodyList(this.props.postObj);
            if (this.props.isOpen) {
                this.removeBodyScrollBar();
            }
        } else if (this.props.isOpen !== prevProps.isOpen) {
            this.updateUrl(this.props.postObj);
            if (this.props.isOpen) {
                // this.scrollToTopOfPage();
                this.removeBodyScrollBar();
            } else {
                this.scrollToSharingKnowledgeSection();
                this.addBodyScrollBar();
            }
        }
    }
    openPost(postObj) {
        this.updateUrl(postObj);
        // scroll to top
        // this.scrollToTopOfPage();
    }
    closePostView() {
        this.props.closePost();
    }
    removeBodyScrollBar() {
        $('body,html').css('overflow', 'hidden');
    }
    addBodyScrollBar() {
        $('body,html').css('overflow', 'inherit');
    }
    scrollToTopOfPage() {
        $('body,html').animate({
            'scrollTop': 0
        }, 550);
    }
    scrollToSharingKnowledgeSection() {
        var jump = $(".icon-selection-container");
        var new_position = $(jump).offset();
        $('html, body').stop().animate({ scrollTop: new_position.top }, 500);
    }
    updateUrl(postObj) {
        if (postObj && postObj.fields) {
            let title = postObj.fields.postTitle;
            // replace spaces with dashes
            window.history.replaceState(null, null, "/news/" + title.replace(/\s+/g, '-').toLowerCase());
            this.setState({ sharingUrl: window.location.href });
        }
    }
    populatePostBodyHelper = (postFeaturesList, isBodyBottomList = false) => {
        let bodyObjList = [];
        if (postFeaturesList) {
            for (let i = 0; i < postFeaturesList.length; i++) {
                if (postFeaturesList[i] && postFeaturesList[i].fields) {
                    bodyObjList.push({
                        sideBySideReference: postFeaturesList[i].fields.sideBySideReference,
                        postBodyModel: postFeaturesList[i].fields
                    });
                }
            }

            this.preRenderPostBody(bodyObjList, isBodyBottomList);
        }
    }
    populatePostBodyList(postObj) {
        if (postObj && postObj.fields) {

            if (postObj.fields.postFeatures) {
                this.populatePostBodyHelper(postObj.fields.postFeatures, false);
            } else {
                this.setState({ bodyObjList: [] });
            }

            if (postObj.fields.postBottomFeatures) {
                this.populatePostBodyHelper(postObj.fields.postBottomFeatures, true);
            } else {
                this.setState({ bodyBottomObjList: [] });
            }
        }
    }
    extractFieldsFromObjects(bodyFeature) {
        if (bodyFeature.text) {
            return {
                type: this.postBodyModelType.TEXT_FIELD,
                text: bodyFeature.text
            };
        } else if (bodyFeature.image) {
            return {
                type: this.postBodyModelType.IMAGE_FIELD,
                imageUrl: bodyFeature.image.fields.file.url,
                imageCaption: bodyFeature.imageCaption
            };
        } else if (bodyFeature.statisticsNumber && bodyFeature.statisticsText) {
            return {
                type: this.postBodyModelType.STAT_FIELD,
                statNumber: (bodyFeature.statisticsNumber + "").replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"),
                statText: bodyFeature.statisticsText
            };
        } else if (bodyFeature.pdfDocument && bodyFeature.pdfDocument.fields && bodyFeature.pdfDocument.fields.file && bodyFeature.pdfDocument.fields.file.url) {
            return {
                type: this.postBodyModelType.PDF_FIELD,
                pdfUrl: bodyFeature.pdfDocument.fields.file.url,
                title: bodyFeature.title,
                description: bodyFeature.description,
                previewImageUrl: bodyFeature.previewImage ? bodyFeature.previewImage.fields.file.url : null
            };
        } else if (bodyFeature.video && bodyFeature.video.fields && bodyFeature.video.fields.file && bodyFeature.video.fields.file.url) {
            return {
                type: this.postBodyModelType.VIDEO_FIELD,
                videoUrl: bodyFeature.video.fields.file.url
            };
        }
        return null;
    }
    preRenderPostBody(bodyObjList, isBodyBottomList = false) {
        let bodyObjListGroupedBeforeRender = [];
        if (bodyObjList && bodyObjList.length > 0) {
            for (let i = 0; i < bodyObjList.length; i++) {
                if (bodyObjList[i] && bodyObjList[i].postBodyModel) {
                    let groupedObject = [];

                    let bodyFeatureObj = this.extractFieldsFromObjects(bodyObjList[i].postBodyModel);
                    if (bodyFeatureObj) {
                        groupedObject.push(bodyFeatureObj);
                    }

                    let bodyFeatureSideBySideReference = null;
                    if (bodyObjList[i].sideBySideReference && bodyObjList[i].sideBySideReference.fields) {
                        bodyFeatureSideBySideReference = this.extractFieldsFromObjects(bodyObjList[i].sideBySideReference.fields);
                        if (bodyFeatureSideBySideReference) {
                            groupedObject.push(bodyFeatureSideBySideReference);
                        }
                    }

                    bodyObjListGroupedBeforeRender.push({ itemList: groupedObject });
                }
            }
        }

        this.setState(isBodyBottomList ? { bodyBottomObjList: bodyObjListGroupedBeforeRender } : { bodyObjList: bodyObjListGroupedBeforeRender });
    }
    downloadPdf(pdfUrl, pdfTitle) {
        this.setState({ downloadUrl: pdfUrl, downloadTitle: pdfTitle }, () => {
            this.downloadRef.click();
        });
    }
    renderPostBody(bodyObjList, isBodyBottomList = false) {
        let listOfReadyObjFinal = [];

        return <div className="">
            {bodyObjList.map((postBodyItemContainer, postBodyIndex) => {
                let listOfReadyObj = [];
                let tempHtmlFinalStringArray = [];
                let isModelTypeList = [];

                for (let i = 0; i < postBodyItemContainer.itemList.length; i++) {
                    let postBodyItem = postBodyItemContainer.itemList[i];
                    isModelTypeList.push(postBodyItem.type);

                    if (postBodyItem.type === this.postBodyModelType.TEXT_FIELD) {
                        {/* var rawMarkup = marked(postBodyItem.text); */ }
                        var documentRichText = postBodyItem.text;

                        let tempHtml = <div key={postBodyIndex}
                            className={["post-body-section", "post-body-text-field"].join(" ")}>
                            {/* postBodyItem.dropdown === textTypes.Heading ? 'post-body-text-field-heading' : ''].join(" ")}> */}
                            {/* <div dangerouslySetInnerHTML={{ __html: rawMarkup }} /> */}
                            {documentToReactComponents(documentRichText, this.richTextRenderOptions)}
                        </div>
                        listOfReadyObj.push(tempHtml);
                    } else if (postBodyItem.type === this.postBodyModelType.IMAGE_FIELD) {
                        let tempHtml = <div key={postBodyIndex} className="post-body-section post-body-image-field">
                        <img src={postBodyItem.imageUrl + "?h=1000&q=85"} alt="bodyfield" />
                            {postBodyItem.imageCaption && <div className="post-body-image-field-text">{postBodyItem.imageCaption}</div>}
                        </div>
                        listOfReadyObj.push(tempHtml);
                    } else if (postBodyItem.type === this.postBodyModelType.STAT_FIELD) {
                        let tempHtml = <div key={postBodyIndex} className="post-body-section post-body-stats-field">
                            <div className="post-body-stats-field-number">{postBodyItem.statNumber}</div>
                            <div className="post-body-stats-field-text">{postBodyItem.statText}</div>
                        </div>
                        listOfReadyObj.push(tempHtml);
                    } else if (postBodyItem.type === this.postBodyModelType.PDF_FIELD) {
                        let tempHtml = <div key={postBodyIndex} className="post-body-section post-body-pdf-field">
                             <div className="row">
                                <PdfComponent pdfUrl={postBodyItem.pdfUrl} classList={"col-md-6 post-body-pdf-image"} />
                                {/* <div className="col-md-6 post-body-pdf-image">
                                    {this.renderPDF(postBodyItem.pdfUrl)}
                                </div> */}
                                <div className="col-md-10">
                                    <div className="post-body-pdf-title">{postBodyItem.title}</div>
                                    <div className="post-body-pdf-description">{postBodyItem.description}</div>
                                    <div className="post-body-pdf-download-section" onClick={() => this.downloadPdf(postBodyItem.pdfUrl, postBodyItem.title)}>
                                        <span className="post-body-pdf-download-section-icon"><ArrowRightIcon /></span>
                                        <span className="post-body-pdf-download-section-text">Download PDF</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        listOfReadyObj.push(tempHtml);
                    } else if (postBodyItem.type === this.postBodyModelType.VIDEO_FIELD) {
                        let tempHtml = <div key={postBodyIndex} className="post-body-section post-body-video-field">
                            <ReactPlayer height={'100%'} url={postBodyItem.videoUrl} controls />
                        </div>
                        listOfReadyObj.push(tempHtml);
                    }
                }

                {
                    listOfReadyObj.map((eachPostBodyItem, eachPostBodyItemIndex) => {
                        if (postBodyItemContainer.itemList.length > 1) {
                            tempHtmlFinalStringArray.push(<div className={['col-lg-8 post-body-split-view',
                                isModelTypeList[eachPostBodyItemIndex] != this.postBodyModelType.TEXT_FIELD ? 'wrap-around-object' : '',
                                isModelTypeList[eachPostBodyItemIndex] === this.postBodyModelType.TEXT_FIELD ? 'wrap-around-text' : ''].join(' ')}>
                                {eachPostBodyItem}
                            </div>);
                        }

                        if (postBodyItemContainer.itemList.length == 1) {
                            listOfReadyObjFinal.push(eachPostBodyItem);
                        } else if (postBodyItemContainer.itemList.length > 1 && eachPostBodyItemIndex == 1) {
                            // specfic case for text wrapping, the text alwayss has to be above the image container
                            // for this case, move the text to be above the image, if it's after when coming from CMS
                            let isForceImageToRight = false;
                            if (isModelTypeList[0] === this.postBodyModelType.TEXT_FIELD && isModelTypeList[1] != this.postBodyModelType.TEXT_FIELD) {
                                tempHtmlFinalStringArray.unshift(tempHtmlFinalStringArray.splice(1, 1)[0]);
                                isForceImageToRight = true;
                            }

                            listOfReadyObjFinal.push(<div className={["post-body-split-view-container", isForceImageToRight ? 'post-body-split-view-force-image-right' : ''].join(' ')}>
                                {tempHtmlFinalStringArray.map((sideBySideItem) => {
                                    return sideBySideItem;
                                })}
                            </div>);
                        }
                    })
                }

            })}

            {listOfReadyObjFinal.map((eachPostBodyItem, eachPostBodyItemIndex) => {
                return <div key={eachPostBodyItemIndex} className="post-body-item-view-container">{eachPostBodyItem}</div>
            })}
        </div>
    }
    openEmailSharingMenu() {
        this.setState((prevState, props) => ({ isEmailSharingDetailsOpen: !prevState.isEmailSharingDetailsOpen, isCopiedLink: false }));
    }
    shareEmail() {
        if (this.state.postObj && this.state.postObj) {
            this.setState({
                shareLinkOpenInNewTab: false,
                shareLink: "mailto:?subject=" + this.state.postObj.fields.postTitle + "&body=" + this.state.sharingUrl
            }, () => {
                this.shareRef.click();
            });
        }
    }
    shareLinkedIn() {
        if (this.state.postObj && this.state.postObj) {
            this.setState({ shareLinkOpenInNewTab: true, shareLink: "https://www.linkedin.com/shareArticle?mini=true&url=" + this.state.sharingUrl }, () => {
                this.shareRef.click();
            });
        }
    }
    shareTwitter() {
        if (this.state.postObj && this.state.postObj) {
            this.setState({
                shareLinkOpenInNewTab: true,
                shareLink: "http://twitter.com/share?text=" + this.state.postObj.fields.postTitle + "&url=" + this.state.sharingUrl
            }, () => {
                this.shareRef.click();
            });
        }
    }
    shareFacebook() {
        if (this.state.postObj && this.state.postObj) {
            this.setState({ shareLinkOpenInNewTab: true, shareLink: "https://www.facebook.com/sharer/sharer.php?u=" + this.state.sharingUrl }, () => {
                this.shareRef.click();
            });
        }
    }
    copyLink(url) {
        var dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.setAttribute('value', url);
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
        this.setState({ isCopiedLink: true });
    }
    replaceWithCustomStyle = (contentfulData) => {
        let headerImageCustomStyle = {};
        
        if (contentfulData.headerImageDisplacement && contentfulData.headerImageDisplacement <= 100 && contentfulData.headerImageDisplacement >= 0) {
            headerImageCustomStyle.height = contentfulData.headerImageDisplacement + "vh";
        }
        if (contentfulData.articleImagePosition && this.acceptableImagePositions.includes(contentfulData.articleImagePosition)) {
            headerImageCustomStyle["object-position"] = contentfulData.articleImagePosition.toLowerCase();
        }

        return headerImageCustomStyle;
    }
    render() {
        const isShowPopUp = this.props.isOpen && this.state.postObj && this.state.postObj.fields;
        return (
            <React.Fragment>
                <a ref={(ref) => { this.downloadRef = ref }} style={{ display: 'none' }} target={"_blank"} href={this.state.downloadUrl} download={this.state.downloadTitle}></a>
                <a target={this.state.shareLinkOpenInNewTab ? "_blank" : ''} ref={(ref) => { this.shareRef = ref }}
                    style={{ display: 'none' }} href={this.state.shareLink ? encodeURI(this.state.shareLink) : ''}></a>
                {isShowPopUp && <div className={`PostPopup row`}>
                    <div className="post-container-placement">
                        {this.state.postObj.fields.postImage && <div className="post-hero-image-container">
                            <div className="post-close-button-container">
                                <CloseIcon onClick={() => this.closePostView()}></CloseIcon>
                            </div>
                            <img style={this.replaceWithCustomStyle(this.state.postObj.fields)} className="post-hero-image"
                                src={this.state.postObj.fields.articleBanner ? this.state.postObj.fields.articleBanner.fields.file.url + "?h=1000&q=85" : this.state.postObj.fields.postImage.fields.file.url + "?h=1000&q=85"}
                                alt="hero"></img>
                        </div>}
                        <div className="post-title-container post-padding-side">
                            <div className="post-title">{this.state.postObj.fields.postTitle}</div>
                            {/* <div className="post-body-container-right sharing-links-control-display-scroll">
                                {this.state.sharingUrl && <div className="social-icons-container">
                                    <div className="social-icons-list-title">SHARE</div>
                                    <div className={['social-icon-container', this.state.isEmailSharingDetailsOpen ? 'email-sharing-details-open' : ''].join(" ")} onClick={() => this.openEmailSharingMenu()}>
                                        <i className="fas fa-envelope"></i>
                                    </div>
                                    {this.state.isEmailSharingDetailsOpen && <div className="social-icon-email-menu-container">
                                        <div className="social-icon-email-menu-submenu social-icon-email-menu-default-program" onClick={() => this.shareEmail()}>
                                            <i className="fas fa-envelope"></i><span>Email Article</span>
                                        </div>
                                        <div className="social-icon-email-menu-submenu social-icon-email-menu-copy-link" onClick={() => this.copyLink(this.state.sharingUrl)}>
                                            <div className="social-icon-email-menu-copy-link-text">{this.state.isCopiedLink ? 'Link copied' : "Click to copy link"}</div>
                                            <div className={["social-icon-email-menu-copy-link-url",
                                                this.state.isCopiedLink ? 'is-copied-link' : ''].join(" ")}>
                                                {this.state.sharingUrl}
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    <div className="social-icon-container" onClick={() => this.shareLinkedIn()}>
                                        <i className="fab fa-linkedin-in"></i>
                                    </div>
                                    <div className="social-icon-container" onClick={() => this.shareTwitter()}>
                                        <i className="fab fa-twitter"></i>
                                    </div>
                                    <div className="social-icon-container" onClick={() => this.shareFacebook()}>
                                        <i className="fab fa-facebook-f"></i>
                                    </div>
                                </div>
                                }
                            </div> */}
                        </div>
                        <div className="post-flex-body-container">
                            <div className="post-body-container post-padding-side row">
                                <div className="post-body-container-left col-md-12">
                                    <div className="post-body-date post-body-section">Post Date: <span>{this.state.postObj.formattedDate}</span></div>
                                    {/* make a reference of all object types here. */}
                                    {this.renderPostBody(this.state.bodyObjList)}
                                </div>
                                <div className="col-md-1"></div>
                                <div className="post-body-container-right col-md-3">
                                    {this.state.sharingUrl && <div className="social-icons-container">
                                        <div className="social-icons-list-title">SHARE</div>
                                        <div className={['social-icon-container', this.state.isEmailSharingDetailsOpen ? 'email-sharing-details-open' : ''].join(" ")} onClick={() => this.openEmailSharingMenu()}>
                                            <i className="fas fa-envelope"></i>
                                        </div>
                                        {this.state.isEmailSharingDetailsOpen && <div className="social-icon-email-menu-container">
                                            <div className="social-icon-email-menu-submenu social-icon-email-menu-default-program" onClick={() => this.shareEmail()}>
                                                <i className="fas fa-envelope"></i><span>Email Article</span>
                                            </div>
                                            <div className="social-icon-email-menu-submenu social-icon-email-menu-copy-link" onClick={() => this.copyLink(this.state.sharingUrl)}>
                                                <div className="social-icon-email-menu-copy-link-text">{this.state.isCopiedLink ? 'Link copied' : "Click to copy link"}</div>
                                                <div className={["social-icon-email-menu-copy-link-url",
                                                    this.state.isCopiedLink ? 'is-copied-link' : ''].join(" ")}>
                                                    {this.state.sharingUrl}
                                                </div>
                                            </div>
                                        </div>
                                        }
                                        <div className="social-icon-container" onClick={() => this.shareLinkedIn()}>
                                            <i className="fab fa-linkedin-in"></i>
                                        </div>
                                        <div className="social-icon-container" onClick={() => this.shareTwitter()}>
                                            <i className="fab fa-twitter"></i>
                                        </div>
                                        <div className="social-icon-container" onClick={() => this.shareFacebook()}>
                                            <i className="fab fa-facebook-f"></i>
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>
                            {this.state.bodyBottomObjList && this.state.bodyBottomObjList.length > 0 && <div className="post-extra-content-container post-padding-side">
                                <div className="">{this.renderPostBody(this.state.bodyBottomObjList)}</div>
                            </div>}
                        </div>
                        {(this.state.postObj.priorArticleText || this.state.postObj.nextArticleText) && <div className="post-redirection-container post-padding-side row">
                            <div className="post-redirection-section col-md-7">
                                {this.state.postObj.priorArticleText &&
                                    <div onClick={() => this.props.loadInPreviousArticle(this.state.postObj.currentIndex)}>
                                        <React.Fragment>
                                            <div className="post-redirection-default-text">PREVIOUS</div>
                                            <div className="post-redirection-title">{this.state.postObj.priorArticleText}</div>
                                        </React.Fragment>
                                    </div>
                                }
                            </div>
                            <div className="col-md-2"></div>
                            <div className="post-redirection-section col-md-7 text-align-right">
                                {this.state.postObj.nextArticleText &&
                                    <div onClick={() => this.props.loadInNextArticle(this.state.postObj.currentIndex)}>
                                        <React.Fragment>
                                            <div className="post-redirection-default-text">NEXT</div>
                                            <div className="post-redirection-title">{this.state.postObj.nextArticleText}</div>
                                        </React.Fragment>
                                    </div>
                                }
                            </div>
                        </div>}
                    </div>
                </div>
                }
            </React.Fragment>
        );
    }

};
